import type { SVGProps } from "react";
const SvgFacebook01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2.5 12c0-4.478 0-6.718 1.391-8.109S7.521 2.5 12 2.5c4.478 0 6.718 0 8.109 1.391S21.5 7.521 21.5 12c0 4.478 0 6.718-1.391 8.109S16.479 21.5 12 21.5c-4.478 0-6.718 0-8.109-1.391S2.5 16.479 2.5 12Z"
    />
    <path
      fill="currentColor"
      d="M17 8.75a.75.75 0 0 0 0-1.5v1.5M16 8v.75zm-4.75 13.5a.75.75 0 0 0 1.5 0h-1.5M10 13.25a.75.75 0 0 0 0 1.5v-1.5m5 1.5a.75.75 0 0 0 0-1.5v1.5M17 8v-.75h-1v1.5h1zm-5 4h-.75v9.5h1.5V12zm4-4v-.75c-.922 0-1.688-.002-2.294.08-.628.084-1.195.27-1.65.725l.53.53.53.531c.13-.13.328-.237.79-.3.482-.064 1.13-.066 2.094-.066zm-4 4h.75c0-.964.002-1.612.066-2.095.063-.461.17-.659.3-.789l-.53-.53-.53-.53c-.456.455-.642 1.022-.726 1.65-.082.606-.08 1.372-.08 2.294zm-2 2v.75h5v-1.5h-5z"
    />
  </svg>
);
export default SvgFacebook01;
